import { queryKeys } from 'config/queryKeys'
import { SalesRes } from 'features/sales'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchSales = (id: string) => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: sales,
		isFetching: isSalesLoading,
		isSuccess: isSalesSuccess
	} = useQuery<SalesRes>({
		queryKey: queryKeys.sales.list(`account_id=${id}`),
		queryFn: () => axiosPrivate.get(`/sales/?account_id=${id}`),
		enabled: !!auth.accessToken
	})

	return {
		sales,
		isSalesLoading,
		isSalesSuccess
	}
}
